import { render, staticRenderFns } from "./ResetMechanismsWarning.vue?vue&type=template&id=c6d56076&"
import script from "./ResetMechanismsWarning.vue?vue&type=script&lang=js&"
export * from "./ResetMechanismsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports